import { store } from "./store.js";

export default (type, data = {})=>{
  store.dispatch({type, data});
};
